"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deindentText = void 0;
const min_1 = __importDefault(require("lodash/min"));
const deindentText = (input) => {
    const lines = input.split('\n');
    const starting_indents = (0, min_1.default)(lines.filter(x => x.trim().length > 0).map(x => x.search(/\S/) ?? 0)) ?? 0;
    return lines
        .map(line => line.substring(starting_indents).trimEnd())
        .join('\n')
        .trim();
};
exports.deindentText = deindentText;
//# sourceMappingURL=strings.js.map